import React from "react";
import { Navigate } from "react-router-dom";

const AuthRoute = ({ children, org }) => {
  const token = sessionStorage.getItem("token");
  const isCompany = sessionStorage.getItem("org");

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  if (isCompany && !org) {
    return <Navigate to="/company/dashboard" replace />;
  }

  if (!isCompany && org) {
    return <Navigate to="/app/welcome" replace />;
  }

  return children;
};

export default AuthRoute;
